import { TLinkGroup } from '@ingeniorforeningen/figurine-core/build/application/Header/parts/LocalNavbar';
import { HeaderLocalLinks, Links } from '../types';
import { replaceHostName, stripText } from './textsHelpers';

export const setHeaderLocalLinks = (links: HeaderLocalLinks | undefined) => {
  if (!links) {
    return [];
  }

  const items: TLinkGroup[] = [];

  const subLinks = (links: Links[]) => {
    if (!links.length) {
      return [];
    }
    const items = links.filter((value: any) => value.title !== '');

    return items.map((item: any) => ({
      text: stripText(item.title),
      href: stripText(replaceHostName(item.url)),
    }));
  };

  for (const key in links) {
    const link = links[key as keyof HeaderLocalLinks];
    items.push({
      header: stripText(link.title),
      href: '',
      items: [
        {
          header: '',
          links: subLinks(link.column1),
        },
        {
          header: '',
          links: subLinks(link.column2),
        },
        {
          header: '',
          links: subLinks(link.column3),
        },
      ],
    });
  }
  return items;
};
